import { Button, ThemeIcon } from '@mantine/core';
import { IconDownload, IconExternalLink, IconFile, IconMovie } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { LinkedEntitiesSection } from 'src/Components/EntityLinks/LinkedEntitiesSection';
import { LinkableEntityType } from 'src/Services/API/EntityLinks.api';
import { FileInfoDtoTypeEnum } from 'src/Services/API/generated';

import styles from './DocumentDetails.module.scss';
import { Props } from './DocumentDetails.types';

const DocumentDetails = ({ file }: Props) => {
  const { t } = useTranslation();

  const isExternalLink = file.type === FileInfoDtoTypeEnum.ExternalLink;
  const FileIcon = isExternalLink
    ? IconExternalLink
    : file.type === FileInfoDtoTypeEnum.Video
      ? IconMovie
      : IconFile;
  const openUrl = isExternalLink
    ? file.externalUrl
    : (file.urls?.previewLargeUrl ?? file.urls?.fileUrl);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <ThemeIcon size={48} radius="md" variant="light">
          <FileIcon size={24} />
        </ThemeIcon>
        <span className={styles.title}>{file.name}</span>
      </div>

      {openUrl && (
        <Button
          component="a"
          href={openUrl}
          target="_blank"
          rel="noopener noreferrer"
          variant="light"
          leftSection={isExternalLink ? <IconExternalLink size={16} /> : <IconDownload size={16} />}
        >
          {isExternalLink
            ? t('documents.details.openLink', 'Ouvrir le lien')
            : t('documents.details.download', 'Télécharger')}
        </Button>
      )}

      <LinkedEntitiesSection
        entityType={LinkableEntityType.VirtualFile}
        entityId={file.id}
        entityTitle={file.name}
      />
    </div>
  );
};

export default DocumentDetails;
